import React, { Fragment } from 'react';
import EnterCity from './components/EnterCity'

function App() {
  return (
    <Fragment>
      <EnterCity />
    </Fragment>
  );
}

export default App;
